import React, {useState} from 'react';
import {AccountStoreSettingDto} from "../../../../../../../dtos";
import {makeStyles} from "@mui/styles";
import StoreSettingsRow from "./storeSettingsRow";
import {Table, TableCell, TableHead, TableRow} from "@mui/material";

const useStyles = makeStyles(() => ({
    storeSettingsTableWrapper: {
        maxHeight: "60vh",
        overflow: "auto",
        border: "2px solid #e2e2e2",
        borderRight: "none",
    },
    storeSettingsTable: {
        borderCollapse: "collapse",
        margin: 0
    },
    storeSettingTableHeadRow: {
        "& > .MuiTableCell-root": {
            verticalAlign: "bottom",
            borderBottom: "2px solid #dee2e6",
            textAlign: "center",
            border: "none",
            zIndex: 1,
            minWidth: "32px",
            padding: "8px",
            backgroundColor: "#d4dade",
            fontWeight: "700",
            position: "sticky",
            top: 0,
            boxShadow: "0 0 0 2px #e8e8e8",
            borderTop: 0,
            borderRight: "2px solid #e2e2e2"
        }
    }
}))

interface IGuiThemesTable {
    storeSettingArray: AccountStoreSettingDto[];
    onEdit: (storeSettingData: AccountStoreSettingDto) => void;
    onDelete: (storeSettingData: AccountStoreSettingDto) => void;
    setDefaultSettingForStore: (storeSettingData: AccountStoreSettingDto) => void;
}

const StoreSettingsTable: React.FC<IGuiThemesTable> = ({
                                                           storeSettingArray,
                                                           onEdit,
                                                           onDelete,
                                                           setDefaultSettingForStore
                                                       }) => {
    const classes = useStyles();
    const [isCloseMenu, setIsCloseMenu] = useState(true);

    const onScroll = () => {
        setIsCloseMenu(true);
    }

    const items = storeSettingArray.map((storeSetting: AccountStoreSettingDto) => {
        return <StoreSettingsRow
            key={storeSetting.id}
            storeSettingData={storeSetting}
            setIsCloseMenu={setIsCloseMenu}
            isCloseMenu={isCloseMenu}
            onEdit={onEdit}
            onDelete={onDelete}
            setDefaultSettingForStore={setDefaultSettingForStore}
        />

    })

    return (
        <div className={classes.storeSettingsTableWrapper}>
            <Table className={classes.storeSettingsTable} onScroll={onScroll}>
                <TableHead>
                    <TableRow className={classes.storeSettingTableHeadRow}>
                        <TableCell sx={{width: '24%'}}>Store Setting Name</TableCell>
                        <TableCell sx={{width: '24%'}}>Store Logo</TableCell>
                        <TableCell sx={{width: '5%'}}>Color</TableCell>
                        <TableCell sx={{width: '5%'}}>Background</TableCell>
                        <TableCell sx={{width: '12%'}}>Shelves</TableCell>
                        <TableCell sx={{width: '30%'}}>Font</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>

                <tbody>{items}</tbody>
            </Table>
        </div>
    )
}

export default StoreSettingsTable